import React, { lazy } from "react";
import { Helmet } from "react-helmet-async";
import LandHeader from "../components/landing/LandHeader";
import LandMobileHeader from "../components/landing/LandmobileHeader";
import LandHero from "../components/landing/Hero";
import LandingProductsMumbai from "../components/landing/LandingProductsMumbai";
import CrossMarquee from "../components/crossMarquee";
import ProductRange from "../components/landing/productRange";
import DqLandPre from "../components/landing/dqPrefooter";
import JsonLd from "../components/JsonLd";
import { webPageJsonLd } from "../utils/seo";

const AudioControl = lazy(() => import('../components/AudioControl'));
const pageDescription = "Order Snackster party snacks in Mumbai. Explore ready to cook chicken nuggets, popcorn, fingers, sausages, burger patties, and quick starters.";
const pageText = "From apartment get-togethers to weekend watch parties, Snackster helps Mumbai hosts serve hot chicken snacks with less prep. Explore ready to cook nuggets, chicken popcorn, fingers, sausages, burger patties, and party-friendly starters available through Mumbai online and offline store partners.";

export default function LandingPageMumbai() {
  return (
    <>
      <Helmet>
        <title>Party Snacks in Mumbai | Ready to Cook Chicken Snacks - Snackster</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href="https://www.snackster.co.in/party-snacks-mumbai" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Party Snacks in Mumbai | Ready to Cook Chicken Snacks - Snackster" />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content="https://www.snackster.co.in/party-snacks-mumbai" />
        <meta property="og:image" content="https://www.snackster.co.in/images/snackster_logo.svg" />
        <meta property="og:image:width" content="523" />
        <meta property="og:image:height" content="219" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Party Snacks in Mumbai | Ready to Cook Chicken Snacks - Snackster" />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content="https://www.snackster.co.in/images/snackster_logo.svg" />
        <meta name="twitter:site" content="@SnehaSnackster" />
      </Helmet>
      <JsonLd data={webPageJsonLd({
        name: 'Ready to Cook Party Snacks in Mumbai',
        url: '/party-snacks-mumbai',
        description: pageDescription,
        text: pageText,
      })} />
      <h1 className="d-none">Ready to Cook - Party Snacks in Mumbai</h1>
      <AudioControl />
      <LandHeader />
      <LandMobileHeader />
      <LandHero />
      <LandingProductsMumbai />
      <CrossMarquee />
      <ProductRange />
      <div className="container mb-5">
        <h2 className="text-center text-black pt-2 pb-5" style={{ fontFamily: "'Blasto Distort', sans-serif", fontSize: "24px" }}>Welcome to Dulquer's birthday party!</h2>
        <iframe width="100%" height="600" className="d-md-block d-none pb-5 w-75 m-auto" src="https://www.youtube.com/embed/wxNQJRy-oMM?si=bBmYlOC7Tc4DTHNp" title="Snackster Mumbai party snacks video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        <iframe width="100%" height="200" className="d-md-none d-block m-auto" src="https://www.youtube.com/embed/wxNQJRy-oMM?si=bBmYlOC7Tc4DTHNp" title="Snackster Mumbai party snacks video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
      </div>
      <DqLandPre />
    </>
  );
}
